"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../../../../hooks");
var _utils = require("../../../../../utils");
var _ui = require("../../../../ui");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledAlert = (0, _styledComponents.default)(_ui.Alert)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: 20px;\n  ", "\n  ", "\n"])), _utils.mediaQuery.lessThan('md')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-bottom: 15px;\n  "]))), _utils.mediaQuery.greaterThan('md')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-bottom: 0;\n  "]))));
var Footer = function Footer(_ref) {
  var fiat = _ref.fiat;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  var props = (0, _hooks.useWithdrawContext)();
  return /*#__PURE__*/_react.default.createElement(_ui.Row, {
    className: "align-items-end"
  }, /*#__PURE__*/_react.default.createElement(_ui.Col, null, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    color: "secondary",
    disabled: props.formSubmitDisabled,
    wide: true
  }, t('send')), /*#__PURE__*/_react.default.createElement(StyledAlert, {
    component: _ui.Small
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: fiat ? 'libTransfers:sendFiatAttention' : 'libTransfers:sendAttention'
  }, /*#__PURE__*/_react.default.createElement("b", null)))));
};
exports.Footer = Footer;